import { render, staticRenderFns } from "./AssetsNameList.vue?vue&type=template&id=b3accad8&"
import script from "./AssetsNameList.vue?vue&type=script&lang=js&"
export * from "./AssetsNameList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports